const zh = {
  site_name: '555影视',
  site_slogan: '免费电影在线观看不缓冲',
  nav_home: '首页',
  nav_categories: '电影分类',
  nav_about: '关于我们',
  hero_title: '最新电影 高清大片',
  hero_subtitle: '免费在线观看，画质清晰播放流畅不缓冲',
  hot_movies: '热门推荐',
  new_movies: '最新上映',
  all_categories: '全部分类',
  view_detail: '查看详情',
  rating: '评分',
  year: '年份',
  duration: '时长',
  director: '导演',
  actors: '主演',
  category: '类型',
  language: '语言',
  region: '地区',
  description: '简介',
  back_home: '返回首页',
  breadcrumb_home: '首页',
  breadcrumb_category: '电影分类',
  breadcrumb_about: '关于我们',
  about_title: '关于555影视',
  about_intro: '品牌介绍',
  about_honors: '行业荣誉',
  about_stats: '数据统计',
  about_contact: '联系我们',
  about_mission: '我们的使命',
  footer_rights: '版权所有',
  footer_disclaimer: '本站所有资源信息均来自互联网，仅供学习交流使用',
  search_placeholder: '搜索电影...',
  loading: '加载中...',
  no_movies: '暂无电影',
};

export default zh;